import React from 'react';
import { NAME_MAX_LENGTH, enforceNameConstraints, checkSpecialCharacters } from '../../../../lib/validation';
import { showToastMessage } from '../../../../../../../utils/commonFunctions';
import styles from './GeoFeaturePanel.module.scss';

interface PolygonNameInputProps {
  name: string;
  onNameChange: (name: string) => void;
}

/**
 * Isolated, memoized name input field for GeoFeature polygons.
 * Prevents re-renders when vertices are modified.
 */
export const PolygonNameInput: React.FC<PolygonNameInputProps> = React.memo(({ name, onNameChange }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value;
    const enforced = enforceNameConstraints(rawValue);
    onNameChange(enforced);

    if (enforced.length === NAME_MAX_LENGTH) {
      showToastMessage('info', `Character limit of ${NAME_MAX_LENGTH} reached`);
    }

    if (rawValue !== enforced && rawValue.length > enforced.length) {
      const specialCharError = checkSpecialCharacters(rawValue);
      if (specialCharError) {
        showToastMessage('info', specialCharError);
      }
    }
  };

  return (
    <div className={styles.nameRow}>
      <span className={styles.lbl}>Name</span>
      <div className={`${styles.input} ${styles.text}`}>
        <input
          value={name}
          maxLength={NAME_MAX_LENGTH}
          onChange={handleChange}
          placeholder="Area of Interest_01"
        />
      </div>
    </div>
  );
});

PolygonNameInput.displayName = 'PolygonNameInput';
